/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Tree, Input} from 'antd';
import tDetailActions from 'Actions/taskManage/detail';
import tStatisticActions from 'Actions/taskManage/statistic';
import './index.less';

const {TreeNode} = Tree;
const {Search} = Input;
const treeData = [
  {
    title: '任务名称',
    dataIndex: 'taskName',
    key: 'taskName',
    fixed: 'left',
    width: 190,
    ellipsis: true,
    disabled: true,
  },
  {
    title: '时间',
    dataIndex: 'dayStr',
    key: 'dayStr',
    align: 'center',
    width: 150,
  },
  {
    title: '话务',
    key: 'huawu',
    children: [
      {
        title: '任务量',
        key: 'totalNum',
        dataIndex: 'totalNum',
        width: 180,
        align: 'center',
      },
      {
        title: '外呼量',
        dataIndex: 'calledNum',
        key: 'calledNum',
        width: 180,
        align: 'center',
      },
      {
        title: '回调量',
        dataIndex: 'callbackNum',
        key: 'callbackNum',
        width: 180,
        align: 'center',
      },
      {
        title: '接通量',
        dataIndex: 'answerNum',
        key: 'answerNum',
        width: 180,
        align: 'center',
      },
      {
        title: '接通率',
        dataIndex: 'answerRate',
        key: 'answerRate',
        width: 180,
        align: 'center',
      },
      {
        title: '机器人通话时长(秒)',
        dataIndex: 'serveTime',
        key: 'serveTime',
        width: 180,
        align: 'center',
      },
      {
        title: '平均机器人通话时长(秒)',
        dataIndex: 'avgServeTime',
        key: 'avgServeTime',
        width: 180,
        align: 'center',
      },
      {
        title: '客户数',
        dataIndex: 'connectClientNum',
        key: 'connectClientNum',
        width: 180,
        align: 'center',
      },
      {
        title: '客户接通率',
        dataIndex: 'connectClientRate',
        key: 'connectClientRate',
        width: 180,
        align: 'center',
      },
    ],
  },
  {
    title: '挂机原因次数',
    key: 'hangupExtMap',
    children: [
      {
        title: '客户挂机',
        dataIndex: 'hangupExtMap.user',
        key: 'user',
        width: 100,
        align: 'center',
      },
      {
        title: '未识别挂机',
        dataIndex: 'hangupExtMap.unknown',
        key: 'unknown',
        width: 100,
        align: 'center',
      },
      {
        title: '超时挂机',
        dataIndex: 'hangupExtMap.timeout',
        key: 'timeout',
        width: 100,
        align: 'center',
      },
      {
        title: '结束挂机',
        dataIndex: 'hangupExtMap.normal',
        key: 'normal',
        width: 100,
        align: 'center',
      },
      {
        title: '其他挂机',
        dataIndex: 'hangupExtMap.others',
        key: 'others',
        width: 100,
        align: 'center',
      },
    ],
  },
  {
    title: '交互',
    key: 'jiaohu',
    children: [
      {
        title: '无效会话数',
        dataIndex: 'noUsefulInteractNum',
        key: 'noUsefulInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '1轮有效会话数',
        dataIndex: 'oneUsefulInteractNum',
        key: 'oneUsefulInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '2轮有效会话数',
        dataIndex: 'twoUsefulInteractNum',
        key: 'twoUsefulInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '3轮有效会话数',
        dataIndex: 'threeUsefulInteractNum',
        key: 'threeUsefulInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '4轮有效会话数',
        dataIndex: 'fourUsefulInteractNum',
        key: 'fourUsefulInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '5轮有效会话数',
        dataIndex: 'fiveUsefulInteractNum',
        key: 'fiveUsefulInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '多轮会话数',
        dataIndex: 'moreInteractNum',
        key: 'moreInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '多轮有效会话数',
        dataIndex: 'moreUsefulInteractNum',
        key: 'moreUsefulInteractNum',
        width: 130,
        align: 'center',
      },
      {
        title: '未识别次数',
        dataIndex: 'unknownNum',
        key: 'unknownNum',
        width: 130,
        align: 'center',
      },
      {
        title: '超时未说话次数',
        dataIndex: 'timeoutNum',
        key: 'timeoutNum',
        width: 130,
        align: 'center',
      },
    ],
  },
  {
    title: '标签',
    key: 'labelCountMap',
    dataIndex: 'labelCountMap',
    width: 250,
    ellipsis: true,
    render: text => (text && text.length ? text.join('、') : '--'),
  },
  {
    title: '有效标签',
    key: 'labelDistinctCountMap',
    dataIndex: 'labelDistinctCountMap',
    width: 250,
    ellipsis: true,
    render: text => (text && text.length ? text.join('、') : '--'),
  },
];
class FilterTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandedKeys: ['huawu', 'hangupExtMap', 'jiaohu'],
      searchValue: '',
      checkedKeys: [
        'taskName',
        'dayStr',
        'totalNum',
        'calledNum',
        'answerNum',
        'answerRate',
        'hangupExtMap',
        'noUsefulInteractNum',
        'oneUsefulInteractNum',
        'moreUsefulInteractNum',
        'unknownNum',
        'timeoutNum',
        'labelDistinctCountMap',
      ],
    };
  }

  // tree节点展开
  onExpand = expandedKeys => {
    this.setState({
      expandedKeys,
    });
  };

  // 搜索关键字
  onChange = e => {
    const {value} = e.target;
    const expandedKeys = this.getParentKey(value);
    this.setState({
      expandedKeys,
      searchValue: value,
    });
  };

  // 搜索结果所在父结点展开
  getParentKey = keyword => {
    const parentKey = [];
    for (let i = 0; i < treeData.length; i++) {
      const node = treeData[i];
      if (node.children) {
        if (node.children.some(item => item.title.indexOf(keyword) > -1)) {
          parentKey.push(node.key);
        }
      }
    }
    return parentKey;
  };

  //  选中节点
  onCheck = checkedKeys => {
    this.setState({checkedKeys});
  };

  getNewColumns = data => {
    const {checkedKeys} = this.state;
    const newColumns = [...data];
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      if (!checkedKeys.includes(node.key)) {
        if (node.children) {
          const children = this.getNewColumns(node.children);
          if (children.length) {
            newColumns[i] = {
              ...newColumns[i],
              children,
            };
          } else {
            newColumns[i] = {};
          }
        } else {
          newColumns[i] = {};
        }
      }
    }
    return newColumns.filter(item => JSON.stringify(item) !== '{}');
  };

  // 保存所选节点
  confirm = () => {
    const {cfunOk} = this.props;
    const {checkedKeys} = this.state;
    const newColumns = this.getNewColumns(treeData);
    const select = checkedKeys
      .filter(
        item =>
          item !== 'huawu' && item !== 'hangupExtMap' && item !== 'jiaohu',
      )
      .join(',');
    cfunOk(newColumns, select);
  };

  render() {
    const {searchValue, expandedKeys, checkedKeys} = this.state;
    const loop = data =>
      data.map(item => {
        const index = item.title.indexOf(searchValue);
        const beforeStr = item.title.substr(0, index);
        const afterStr = item.title.substr(index + searchValue.length);
        const title =
          index > -1 ? (
            <span>
              {beforeStr}
              <span style={{color: '#f50'}}>{searchValue}</span>
              {afterStr}
            </span>
          ) : (
            <span>{item.title}</span>
          );
        if (item.children) {
          return (
            <TreeNode key={item.key} title={title} selectable={false}>
              {loop(item.children)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={item.key}
            title={title}
            selectable={false}
            disabled={item.disabled}
          />
        );
      });
    return (
      <div className="filterTree">
        <div className="title-box">
          <span className="title">显示列表设置</span>
          <span className="confirm-btn" onClick={this.confirm}>
            确定
          </span>
        </div>
        <div>
          <Search
            style={{margin: '8px 0'}}
            placeholder="搜索"
            onChange={this.onChange}
          />
          <Tree
            checkable
            // draggable
            onExpand={this.onExpand}
            expandedKeys={expandedKeys}
            checkedKeys={checkedKeys}
            onCheck={this.onCheck}>
            {loop(treeData)}
          </Tree>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  taskManageList: state.taskManageList,
});

const mapDispatchToProps = dispatch => {
  return {
    DetailActions: bindActionCreators(tDetailActions, dispatch),
    actions: bindActionCreators(tStatisticActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterTree);
